export default __webpack_public_path__ + "static/media/11.5d3539b2.jpg";